import type { MaybeRefOrGetter } from 'vue';
import type { ResolvedMonospaceCollection } from '#layers/data-model/types/schema/resolved-schema';
import { computed, toValue } from 'vue';
import { resolveCollectionDisplayTemplate } from '#layers/data-model/utils/display-template';

export function useCollectionDisplayTemplate(collection: MaybeRefOrGetter<ResolvedMonospaceCollection>) {
	return computed(() => resolveCollectionDisplayTemplate(toValue(collection)));
}
